<template>
  <b-modal
    id="alertRegister"
    content-class="ax-modal-transparent"
    centered
    hide-footer
    hide-header
    hide-actions
    size="md">
    <section class="c-modal c-modal--dark-blur">
      <div
        class="c-modal__dialog"
      >
        <section
          class="p-4">
          <div class="d-flex flex-column align-items-center text-center">
            <h3 class="w-bold fs-25 white"> ¿Ansioso por seguir aprendiendo?</h3>
            <p class="mb-3">
              <template>
                Regístrate para continuar con el curso
              </template>
            </p>

            <button
                @click="openRegistration()"
                class="c-button c-button--primary"
              >
                Registrate
              </button>
          </div>
        </section>
      </div>
    </section>
  </b-modal>
</template>

<script>
export default {
  methods: {
    openRegistration() {
      window.localStorage.setItem('arcux_back_url', window.location.href);
      this.$router.push({
        path: '/ingresar', query: { enroll: this.$route.params.course_id },
      });
    },
  },
};
</script>
